module.exports = __webpack_public_path__ + "static/media/weatherDashboardS.7353fa2f.png";